import { Directive, output, OutputEmitterRef, input, InputSignal } from '@angular/core';

import { CodeAndLabel } from '@models/code-and-label';

@Directive()
export abstract class GiFilesFormTableBase<FILETYPE, INDEXTYPE> {
  readonly fileTypes: InputSignal<CodeAndLabel<FILETYPE>[]> = input<CodeAndLabel<FILETYPE>[]>();

  readonly removeFile: OutputEmitterRef<INDEXTYPE> = output<INDEXTYPE>();
  readonly downloadFile: OutputEmitterRef<number> = output<number>();
  readonly openFileInNewTab: OutputEmitterRef<number> = output<number>();

  emitRemoveFile(index: INDEXTYPE): void {
    this.removeFile.emit(index);
  }

  emitDownloadFile(fileId: number): void {
    this.downloadFile.emit(fileId);
  }

  emitOpenFileInNewTab(fileId: number): void {
    this.openFileInNewTab.emit(fileId);
  }
}
